/* ==========================================================================
   Programme Marguerite - Fends La Bise Cycles
   Animations vanilla : Intersection Observer, compteurs, timeline, marquee.
   Aucune dependance. Le contenu reste lisible si ce fichier ne se charge pas.
   ========================================================================== */
(function () {
  'use strict';

  // Le fichier peut etre reference par plusieurs sections : on n'initialise qu'une fois.
  if (window.__margueriteBooted) return;
  window.__margueriteBooted = true;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktop = window.matchMedia('(min-width: 1000px)');

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ------------------------------------------------------ Reveals au scroll */
  function initReveals(scope) {
    var items = scope.querySelectorAll('.mg-reveal');
    if (!items.length) return;

    if (reduce.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    // Stagger : chaque enfant direct d'un conteneur [data-mg-stagger] recoit un delai.
    scope.querySelectorAll('[data-mg-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-mg-stagger'), 10) || 90;
      var kids = group.querySelectorAll(':scope > .mg-reveal');
      kids.forEach(function (kid, i) {
        kid.style.setProperty('--mg-delay', Math.min(i * step, 520) + 'ms');
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------- Compteurs */
  function initCounters(scope) {
    var nodes = scope.querySelectorAll('[data-mg-count]');
    if (!nodes.length) return;

    var nf = new Intl.NumberFormat('fr-FR');

    function paint(el, value) {
      el.textContent = (el.getAttribute('data-mg-prefix') || '') +
        nf.format(value) +
        (el.getAttribute('data-mg-suffix') || '');
    }

    function run(el) {
      var target = parseFloat(el.getAttribute('data-mg-count')) || 0;
      if (reduce.matches) { paint(el, target); return; }

      var duration = parseInt(el.getAttribute('data-mg-duration'), 10) || 1400;
      var start = null;

      function frame(now) {
        if (start === null) start = now;
        var p = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        paint(el, Math.round(target * eased));
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { run(el); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    nodes.forEach(function (el) {
      paint(el, 0);
      io.observe(el);
    });
  }

  /* --------------------------------------------- Timeline des 4 etapes */
  function initSteps(scope) {
    var rail = scope.querySelector('[data-mg-rail]');
    if (!rail) return;

    var line = rail.querySelector('.mg-steps__line');
    var steps = Array.prototype.slice.call(rail.querySelectorAll('.mg-step'));
    var figures = Array.prototype.slice.call(
      scope.querySelectorAll('.mg-steps__figure img')
    );
    if (!steps.length) return;

    if (figures.length) figures[0].classList.add('is-active');
    steps[0].classList.add('is-active');

    if (reduce.matches) {
      if (line) line.style.setProperty('--mg-progress', 1);
      return;
    }

    var ticking = false;

    function update() {
      ticking = false;
      var rect = rail.getBoundingClientRect();
      var anchor = window.innerHeight * 0.55;

      // Progression du trace entre le haut et le bas de la timeline.
      var span = rect.height || 1;
      var p = (anchor - rect.top) / span;
      p = Math.max(0, Math.min(1, p));
      if (line) line.style.setProperty('--mg-progress', p.toFixed(3));

      // Etape active : la derniere dont le haut est passe sous l'ancre.
      var active = 0;
      steps.forEach(function (step, i) {
        if (step.getBoundingClientRect().top <= anchor) active = i;
      });

      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === active);
      });
      figures.forEach(function (img, i) {
        img.classList.toggle('is-active', i === active);
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ------------------------------------------------- Profondeur des cartes */
  function initDepth(scope) {
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('.mg-depth'));
    if (!nodes.length) return;

    function clear() {
      nodes.forEach(function (el) { el.style.removeProperty('--mg-depth'); });
    }

    if (reduce.matches || !desktop.matches) { clear(); return; }

    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      nodes.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var amp = parseFloat(el.getAttribute('data-mg-depth')) || 14;
        var centre = rect.top + rect.height / 2;
        var ratio = (centre - vh / 2) / vh; // -0.5 .. 0.5 environ
        el.style.setProperty('--mg-depth', (ratio * amp).toFixed(2) + 'px');
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ------------------------------------------------- Boutons magnetiques */
  function initMagnetic(scope) {
    if (reduce.matches || !fine.matches) return;
    scope.querySelectorAll('[data-mg-magnetic]').forEach(function (btn) {
      var raf = null;

      function move(event) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var rect = btn.getBoundingClientRect();
          var x = (event.clientX - rect.left - rect.width / 2) * 0.18;
          var y = (event.clientY - rect.top - rect.height / 2) * 0.3;
          btn.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
        });
      }

      function reset() {
        if (raf) cancelAnimationFrame(raf);
        btn.style.transform = '';
      }

      btn.addEventListener('pointermove', move);
      btn.addEventListener('pointerleave', reset);
      btn.addEventListener('blur', reset);
    });
  }

  /* --------------------------------------------------------- FAQ accordeon */
  function initFaq(scope) {
    scope.querySelectorAll('[data-mg-faq]').forEach(function (list) {
      var buttons = Array.prototype.slice.call(list.querySelectorAll('.mg-faq__q'));

      buttons.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.mg-faq__item');
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          item.classList.toggle('is-open', !open);
        });

        // Navigation clavier entre les questions.
        btn.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowDown') next = buttons[index + 1];
          if (event.key === 'ArrowUp') next = buttons[index - 1];
          if (event.key === 'Home') next = buttons[0];
          if (event.key === 'End') next = buttons[buttons.length - 1];
          if (!next) return;
          event.preventDefault();
          next.focus();
        });
      });
    });
  }

  /* ------------------------------------------- Marquee : duree proportionnelle */
  function initMarquee(scope) {
    scope.querySelectorAll('.mg-marquee').forEach(function (el) {
      var group = el.querySelector('.mg-marquee__group');
      if (!group) return;
      var width = group.scrollWidth;
      if (!width) return;
      var speed = parseFloat(el.getAttribute('data-mg-speed')) || 70; // px/seconde
      el.style.setProperty('--mg-marquee-speed', (width / speed).toFixed(1) + 's');
    });
  }

  /* ------------------------------------------------ Ancres avec offset doux */
  function initAnchors(scope) {
    scope.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reduce.matches ? 'auto' : 'smooth',
          block: 'start'
        });
        // Le focus suit le scroll pour la navigation clavier.
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  /* ------------------------------------------------- Validation formulaire */
  function initForm(scope) {
    var form = scope.querySelector('.mg-form form');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      var invalid = form.querySelector(':invalid');
      if (!invalid) return;
      event.preventDefault();
      invalid.focus();
      invalid.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' });
    });
  }

  /* -------------------------------------------------------------- Demarrage */
  root.classList.add('mg-js');

  function boot() {
    document.querySelectorAll('.mg').forEach(function (scope) {
      if (scope.dataset.mgReady === '1') return;
      scope.dataset.mgReady = '1';
      initReveals(scope);
      initCounters(scope);
      initSteps(scope);
      initDepth(scope);
      initMagnetic(scope);
      initFaq(scope);
      initMarquee(scope);
      initAnchors(scope);
      initForm(scope);
    });
  }

  ready(boot);

  // Rejoue l'initialisation dans l'editeur de theme Shopify.
  document.addEventListener('shopify:section:load', function () {
    root.classList.add('mg-js');
    boot();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target.querySelector('.mg');
    if (scope) delete scope.dataset.mgReady;
  });
})();
